/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamUserDto } from './TeamUserDto';
import {
    TeamUserDtoFromJSON,
    TeamUserDtoFromJSONTyped,
    TeamUserDtoToJSON,
} from './TeamUserDto';

/**
 * 
 * @export
 * @interface TeamDto
 */
export interface TeamDto {
    /**
     * The ID of the team.
     * @type {number}
     * @memberof TeamDto
     */
    id: number;
    /**
     * The display name.
     * @type {string}
     * @memberof TeamDto
     */
    name: string;
    /**
     * The associated users.
     * @type {Array<TeamUserDto>}
     * @memberof TeamDto
     */
    users: Array<TeamUserDto>;
}

/**
 * Check if a given object implements the TeamDto interface.
 */
export function instanceOfTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "users" in value;

    return isInstance;
}

export function TeamDtoFromJSON(json: any): TeamDto {
    return TeamDtoFromJSONTyped(json, false);
}

export function TeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'users': ((json['users'] as Array<any>).map(TeamUserDtoFromJSON)),
    };
}

export function TeamDtoToJSON(value?: TeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'users': ((value.users as Array<any>).map(TeamUserDtoToJSON)),
    };
}

